import React from 'react';
import Grid from '@material-ui/core/Grid'
import {NumberInput, ReferenceInput, required, SelectInput, TextInput} from 'react-admin';

const AdmissionSttConfigFields = props => (
    <React.Fragment>
        <Grid item xs={12} sm={6}>
            <ReferenceInput source="schoolYearId" reference="schoolYears" validate={required()}
                            allowEmpty  {...props} >
                <SelectInput optionText="name"/>
            </ReferenceInput>
        </Grid>
        <Grid item xs={12} sm={6}>
            <TextInput source="name" validate={required()} inputProps={{maxLength: 50}} {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <TextInput source="timeDesc" validate={required()} inputProps={{maxLength: 150}} {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <NumberInput source="startStt" {...props} validate={required()}/>
        </Grid>
        <Grid item xs={12} sm={6}>
            <NumberInput source="endStt" {...props} validate={required()}/>
        </Grid>

    </React.Fragment>
)

export default AdmissionSttConfigFields
